export const DEFAULT_TITLE = '';

export const DEFAULT_IS_LOADING = false;
